const PaymentTerm :any = {
  ONE_HUNDRED_PERCENT_DOWN: '100% Down',
  FIFTY_FIFTY: '50/50',
  THIRTY_SEVENTY: '30/70',
  TWENTY_EIGHTY: '20/80',
  TEN_NINETY: '10/90',
  PAID_ON_DELIVERY: 'Paid on Delivery',
  NET_FIFTEEN: 'Net 15',
  NET_TWENTY: 'Net 20',
  NET_TWENTYFIVE: 'Net 25',
  NET_THIRTY: 'Net 30',
  DUE_ON_RECEIPT: 'Due on Receipt',
  CUSTOM_TERM: 'Custom Term',
  DOWN25_NET30_ON_DELIVERY: '25% Down, Net 30 Upon Delivery',
  DOWN25_NET45_ON_DELIVERY: '25% Down, Net 45 Upon Delivery',
  DOWN25_NET60_ON_DELIVERY: '25% Down, Net 60 Upon Delivery',
  DOWN25_NET90: '25% Down, Net 90',
  DUE_ON_DELIVERY: 'Due on Delivery',
};

export const PurchaseOrderConstant :any = {
  PaymentTerm,
};

export const CostCalculationMethodSetting :any = {
  WEIGHTED: 'WEIGHTED',
  FIFO: 'FIFO',
  LASTPO: 'LAST_PO',
};

export enum DefaultShipToAddress {
  WAREHOUSE = 'warehouse',
  SHIP_TO_ADDRESS = 'ship_to_address',
}

export enum EPOTabs {
  ALL_INCOMING_ORDERS_ACTIVE = 'all_incoming_orders_active',
  ORDERS_ACTIVE = 'active_orders',
  ORDERS_SAMPLE = 'sample_orders',
  ORDERS_COMPLETED = 'completed_orders',
  SHIPMENTS = 'shipments',
  PAYMENTS = 'payments',
  RECEIVING = 'receiving',
}

// Adding JSON-like metadata for tabs
export const CPOTabsMetadata = {
  [EPOTabs.ALL_INCOMING_ORDERS_ACTIVE]: {
    filterData: {},
  },
  [EPOTabs.ORDERS_ACTIVE]: {
    filterData: {
      order_status_id: { lt: 99 },
      order_type: { eq: 1 },
    },
  },
  [EPOTabs.ORDERS_SAMPLE]: {
    filterData: {
      order_status_id: { lt: 99 },
      order_type: { eq: 10 },
    },
  },
  [EPOTabs.ORDERS_COMPLETED]: {
    filterData: {
      order_status_id: { eq: 99 },
    },
  },
};

export enum EPOReceiptStatus {
  AWAITING_SHIPMENT = 'awaiting_shipment',
  PARTIALLY_RECEIVED = 'partially_received',
  FULLY_RECEIVED = 'fully_received',
}

export const poReceiptStatusLookUp = [
  {
    label: 'All',
    value: '',
  },
  {
    label: 'Awaiting Shipment',
    value: EPOReceiptStatus.AWAITING_SHIPMENT,
  },
  {
    label: 'Partially Received',
    value: EPOReceiptStatus.PARTIALLY_RECEIVED,
  },
  {
    label: 'Fully Received',
    value: EPOReceiptStatus.FULLY_RECEIVED,
  },
];
